export default __webpack_public_path__ + "assets/images/0cb90f7dab106d14098337f9c2f08dfa.jpg";